module.exports = __webpack_public_path__ + "img/wonka_logo.29758039.png";